import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipDirective } from '../directives/tooltip.directive.js';

// Yellow «!» on analysis / export controls while the «область интереса» is on — the run
// scans only the region, not the whole stream. Default placement is an absolutely
// positioned SIBLING over the control's top-right corner (the parent wraps both in
// `relative`), never a child of the button: Firefox delivers no mouse events to children
// of a disabled <button>, and a nested [appTooltip] would fight the button's own one.
// `inline` renders it in text flow instead (section headings).
@Component({
  selector: 'app-region-scope-badge',
  standalone: true,
  imports: [TooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'hostClass' },
  template: `<span [appTooltip]="text" tabindex="0" role="img"
        class="flex items-center justify-center w-4 h-4 rounded-full bg-amber-400 text-gray-900 text-[10px] font-extrabold leading-none shadow ring-2 ring-gray-900 cursor-help select-none">!</span>`,
})
export class RegionScopeBadgeComponent {
  @Input() text = '';
  @Input() inline = false;

  get hostClass(): string {
    return this.inline ? 'inline-flex align-middle' : 'absolute -top-1.5 -right-1 z-[1]';
  }
}
